import request from "helper/request";
import { getTimeZone } from "helper/util";

const routeApi = {
  getListHistory: (params) => {
    // Use optimized summary endpoint to prevent OOM issues
    return request.get("/routes/summary", {
      params
    });
  },
  getList: (params) => {
    // Use optimized summary endpoint to prevent OOM issues
    return request.get("/routes/summary", {
      params
    });
  },
  getRoute: (id) => {
    return request.get(`/routes/${id}`);
  },
  getRouteOrder: (id) => {
    return request.get(`/routes/${id}/orders`);
  },
  getDriverLocation: (id) => {
    return request.get(`/routes/${id}/driver-location`);
  },
  getRouteDispatch: async (id) => {
    console.log("===GET ROUTE DISPATCH===", {
      routeId: id,
      endpoint: `/routes/${id}/dispatch`
    });
    const response = await request.get(`/routes/${id}/dispatch`);
    console.log("===GET ROUTE DISPATCH RESPONSE===", response);
    return response;
  },
  export: (startDate, endDate) => {
    return request.get(`/routes/export`, {
      params: {
        startDate,
        endDate
      }
    });
  },
  updateJobStatus: (id, data) => {
    return request.patch(`/jobs/${id}/update-status`, data);
  },
  softDeleteJob: (id) => {
    return request.delete(`/jobs/${id}`);
  },
  assignDriver: (routeId, driverId) => {
    return request.patch(`/admin/routes/${routeId}/assign-driver`, { driverId });
  },
  reassignDriver: (routeId, driverId) => {
    return request.patch(`/admin/routes/${routeId}/reassign-driver`, { driverId });
  },
  cancelRoute: (routeId) => {
    return request.patch(`/routes/${routeId}/cancel-route`);
  },
  getLocation: (id) => {
    return request.get(`/locations/${id}`);
  },
  updateLocation: (data) => {
    const payload = { ...data };
    delete payload.id;
    return request.patch(`/admin/locations/${data.id}`, data);
  },
  getJobPDF: (jobId) => {
    return request.get(`/mvp/jobs/${jobId}/pdf?tz=${getTimeZone()}`);
  },

  updateRouteStatus: (routeId, status) => {
    return request.patch(`/admin/routes/${routeId}/status`, status);
  },

  deliverPackages: (jobId, data, type = "All") => {
    return request.patch(
      `/admin/locations/${jobId}/deliver?quantity=${data?.quantity}&type=${type}&packageId=${data?.packageId}`
    );
  },
  updatePackagesAdmin: (id, packageId, data) => {
    return request.patch(`/mobile/route-locations/${id}/collect/${packageId}`, data);
  },
  getFacturaStatusOptions: () => {
    return request.get("/admin/routes/factura-status-options");
  },
  updateRouteVisibility: (routeId, visibility) => {
    return request.patch(`/routes/${routeId}/update-visibility`, { visibility });
  },
  exportRouteJson: (routeId) => {
    return request.get(`/routes/${routeId}/export?format=json`, {
      responseType: "blob"
    });
  },
  exportRouteCsv: (routeId) => {
    return request.get(`/routes/${routeId}/export?format=csv`, {
      responseType: "blob"
    });
  },
  downloadImportFile: (routeId) => {
    return request.get(`/routes/${routeId}/download-import-file`, {
      responseType: "blob"
    });
  },
  updateRouteEstimates: (routeId, estimateData) => {
    return request.patch(`/routes/${routeId}/update-estimates`, estimateData);
  },
  getSftpPodLog: (jobId) => {
    return request.get(`/jobs/${jobId}/sftp-pod-log`);
  },
  retrySftpPod: (jobId) => {
    return request.post(`/jobs/${jobId}/sftp-pod-retry`);
  }
};

export default routeApi;
